/****************************************************************************************************/
/* Module Imports */
/****************************************************************************************************/

require("./mobile-menu.js");
require('jquery-lazy');
require('jquery-backstretch');
//require('jquery-hoverintent');
require("waypoints/lib/jquery.waypoints.js");
//require("waypoints/lib/shortcuts/sticky.js");
require("jquery-ui/ui/unique-id.js");
require("jquery-ui/ui/focusable.js");
require("jquery-ui/ui/tabbable");
//require("jquery-ui/ui/scroll-parent.js");
require("page-scroll-to-id/jquery.malihu.PageScroll2id.js");
var popup = require("jquery-popup-overlay");
//import Splide from '@splidejs/splide';
//require('@splidejs/splide/dist/css/splide.min.css');
//require('@splidejs/splide/dist/css/themes/splide-default.min.css');

//if (typeof Splide !== "undefined") {
//    window.Splide = Splide; // make splide available to widget scripts
//}

import { Splide } from '@splidejs/splide';
//import { Grid } from '@splidejs/splide-extension-grid';

require('@splidejs/splide/dist/css/splide.min.css');
require('@splidejs/splide/dist/css/themes/splide-default.min.css');
window.Splide = Splide; // make splide available to widget scripts

//import counterUp from 'counterup2';

// set some JS events to new "passive" mode (disabled due to Page Editor issues)
//require('default-passive-events');

// Polyfill for the :focus-visible classs/pseudo
//require('focus-visible');

/****************************************************************************************************/
/* Global Vars */
/****************************************************************************************************/

window.ww; // window width
window.wh; // window width
window.hh;
window.selectedClassName = 'selected'; // the selected class name for menu items
window.menuOpenClassName = 'open'; // the class that defines the open state of the menu
window.fadeInSpeed = 50; // the fade in transition speed
window.fadeOutSpeed = 75; // the fade out transition speed
window.navMouseOutDelay = 600; // the delay before the nav disappears on mouseout
window.mouseOutTimer; // the MouseOut timeout timer 
window.is_responsive = false;
window.lastScrollTop = 0; // used for tracking scroll position and direction
window.scrollDirection = "down"; // default
window.st = window.pageYOffset || document.documentElement.scrollTop;
var $header = $("#header");
function refreshScrollData() {
  // Gets the scrollTop and direction and updates the global variables accordingly
  window.st = window.pageYOffset || document.documentElement.scrollTop;
  if (window.st > lastScrollTop) {
    window.scrollDirection = "down";
  } else {
    window.scrollDirection = "up";
  }
  if (window.st <= window.hh) {
    $header.addClass("near-top");
  } else {
    $header.removeClass("near-top");
  }
  lastScrollTop = window.st <= 0 ? 0 : window.st; // For Mobile or negative scrolling
}
function refreshDimensions() {
  // update calculated dimensions (to be used on resize events, or anytime a manual refresh is required)
  window.ww = document.documentElement.clientWidth; //$(window).width(); - CHANGED to avoid reflows.
  window.wh = document.documentElement.clientHeight; //$(window).height(); - CHANGED to avoid reflows.
  window.hh = $("header").outerHeight();
  let root = document.documentElement;
  //root.style.setProperty('--header-height', window.hh + "px");

  // Check if we are in Mobile (ie Responsive mode)
  if ($('.hamburger').is(":visible")) {
    is_responsive = true;
  } else {
    is_responsive = false;
  }

  // padding to match fixed header height
  //if ($header && $header.length) { //  && is_responsive
  //    $("#wrapper").css({ paddingTop: hh + "px" });
  //} else {
  //    $("#wrapper").css({ paddingTop: 0 });
  //}

  if (!isSitefinityEditor()) {
    refreshScrollData(); // refresh scroll data just in case...
    refreshForcedWidthContainers();
    if (typeof updateSidebarOffsetValues === "function") {
      updateSidebarOffsetValues();
    }
  }

  // force waypoints to recalculate offsets
  Waypoint.refreshAll();
}

/****************************************************************************************************/
/* Document Ready */
/****************************************************************************************************/

window.addEventListener('DOMContentLoaded', function () {
  $header = $("#header");
  refreshDimensions();
  $(window).trigger('resize');
  setTimeout(refreshDimensions, 2000); // re-run after a few seconds to capture any late layout shifts (from fonts loading or other)
});

/****************************************************************************************************/
/* Sticky Header */
/****************************************************************************************************/

//window.addEventListener('DOMContentLoaded', function () {
//    //if ($(".topHeader").length && !window.is_responsive) {
//    //    var stickyheader = new Waypoint.Sticky({
//    //        element: $('.topHeader')[0]
//    //    });
//    //}
//    //if ($(".stickySidebar").length) {
//    //    var sticky = new Waypoint.Sticky({
//    //        element: $('.stickySidebar')[0],
//    //        //wrapper: '<div class="sticky-wrapper" />'
//    //    });
//    //}
//});

/****************************************************************************************************/
/* Side Navigation */
/****************************************************************************************************/

var $scrollAnchors = $(".scroll-anchor").add($(".anchorHeadings h3, .anchorHeadings h2"));
if ($scrollAnchors.length && !isSitefinityEditor()) {
  // only enable if more than one section detected and if not in edit mode

  //var showToolTips = true; // enable/disable tooltips on hover

  // Create the nav element
  //$("#wrapper").append("<div id='scrollNav'></div>");
  //var $scrollNav = $("#scrollNav");
  var $scrollNav = $(".stickySidebar");

  // Add a class to the body (to aid in adding left-space to )
  $("body").addClass("scrollNav");

  // Get all sections with the scrollSection class
  $.each($scrollAnchors, function (index, scrollSection) {
    var $scrollAnchor = $(scrollSection);
    var sectionCount = index + 1;

    // Make sure section has an ID
    var scrollNavID = $scrollAnchor.attr("id");
    if (!scrollNavID) {
      scrollNavID = "scrollSection_" + sectionCount;
      $(this).attr("id", scrollNavID);
    }

    // Make sure section has a title - even if generic
    var scrollNavTitle = $scrollAnchor.text(); // Default title - just grab the text content

    // check for extra attributes to modify the scroll title
    if ($scrollAnchor.data("scroll-section-title")) {
      scrollNavTitle = $scrollAnchor.data("scroll-section-title"); // data attribute based title
    } else if ($scrollAnchor.children(".sf_colsOut").first().data("placeholder-label")) {
      scrollNavTitle = $scrollAnchor.children(".sf_colsOut").first().data("placeholder-label"); // Sitefinity Layout Column Placeholder
    } else if ($scrollAnchor.attr("aria-label")) {
      scrollNavTitle = $scrollAnchor.attr("aria-label");
    }

    // Add the link to the scroll nav
    if (!$scrollNav.find("ul").length) {
      $scrollNav.append("<ul></ul>");
      $scrollNav.find("ul").first().addClass("scrollingSideBar");
    }
    $scrollNav.find("ul").first().append("<li><a href='#" + scrollNavID + "' rel='m_PageScroll2id'><span class='tooltip' title='" + scrollNavTitle + "'>" + scrollNavTitle + "</span></a></li>");
  });

  // Initialize PageScroll2id
  // Documentation: http://manos.malihu.gr/page-scroll-to-id/comment-page-1/
  var linkSelector = "a[rel='m_PageScroll2id']";
  $(linkSelector).mPageScroll2id({
    offset: function () {
      //return Math.max($("header").outerHeight(), $("header .mobileHeader").outerHeight())
      return window.hh;
    },
    // use header height as the scroll offset
    appendHash: false,
    highlightSelector: ".stickySidebar a"
  });
}

//$(document).ready(function () {

//});

/****************************************************************************************************/
/* Sticky Sidebar */
/****************************************************************************************************/

var stickySidebarCloneWrappersOffsets = []; // used elsewhere, don't delete

window.addEventListener('DOMContentLoaded', function () {
  window.$stickySidebar = $(".stickySidebar");
  window.$stickyAnchors = $stickySidebar.find("a");
  //if ($stickySidebar.length) {
  //    var sticky = new Waypoint.Sticky({
  //        element: $stickySidebar[0],
  //        offset: 200 // "stick" when the top of the element is 200px from the top of the page
  //    });
  //}
  if (typeof updateSidebarOffsetValues === "function") {
    updateSidebarOffsetValues();
  }
});
if (typeof checkStickySidebarItems === "function") {
  document.addEventListener('scroll', checkStickySidebarItems);
}

/****************************************************************************************************/
/* Scroll Events */
/****************************************************************************************************/

var mainScrollEvent = function () {
  $header = $("#header");
  refreshScrollData();

  // Scroll-to-top link
  if (lastScrollTop > 450) {
    $('.scrollToTop').fadeIn();
  } else {
    $('.scrollToTop').fadeOut();
  }
  $header.removeClass("down up").addClass(window.scrollDirection);
  if (lastScrollTop === 0) {
    $header.addClass("top");
  } else {
    $header.removeClass("top");
  }
};

// optimized event handler: https://web.dev/uses-passive-event-listeners/
document.addEventListener('scroll', mainScrollEvent, {
  passive: true
});
var hasRunCountUpAnimation = false;
if ($(".factGroup").length) {
  var waypoint = new Waypoint({
    element: $(".factGroup").get(0),
    //document.getElementById('waypoint'),
    handler: function () {
      if (!hasRunCountUpAnimation) {
        var $countUpInstances = $(".countUp");
        if ($countUpInstances.length) {
          $countUpInstances.each(function () {
            var $countUpInstance = $(this);
            var startVal = $countUpInstance.data("start-value");
            var endVal = $countUpInstance.data("end-value");
            numAnim = new CountUp($countUpInstance.attr("id"), startVal, endVal);
            if (!numAnim.error) {
              numAnim.start();
            } else {
              console.error(numAnim.error);
            }
          });
          hasRunCountUpAnimation = true;
        }
      }
    },
    offset: "60%"
  });
}

/****************************************************************************************************/
/* Scroll to location on page */
/****************************************************************************************************/

function scrollToLocation(scrollTo, animate, speed) {
  speed = typeof speed !== 'undefined' ? speed : 500;
  animate = typeof animate !== 'undefined' ? animate : true;
  var $scrollTo = $(scrollTo);
  if ($scrollTo.length) {
    var $container = $('html, body');
    var offset = window.hh;
    //var scrollTop = $scrollTo.offset().top - $container.offset().top + $container.scrollTop() - offset;
    var scrollTop = $scrollTo.offset().top - offset;
    var complete = function () {
      //$("header").removeClass("up").addClass("down"); // finish in "down" mode (hide the header)
      $("header").removeClass("down").addClass("up"); // finish in "up" mode (show the header)
    };
    if (animate) {
      $container.animate({
        scrollTop: scrollTop,
        complete: complete
      }, speed);
    } else {
      // Required so that element on page is loaded
      setTimeout(function () {
        $container.scrollTop(scrollTop);
        complete();
      }, 250);
    }
  }
}
window.scrollToLocation = scrollToLocation;
$(document).on('click', '.scrollToTop', function () {
  $('html, body').animate({
    scrollTop: 0
  }, 800);
  return false;
});

// Smooth scroll to anchor (also fixes anchors on filtered content pages)
$(document).ready(function () {
  if (!isSitefinityEditor()) {
    var anchor = window.location.hash;
    if (anchor && anchor.length > 1 && $(anchor).length) {
      scrollToLocation($(anchor).first());
    }
  }
});

/****************************************************************************************************/
/* Sidebar Anchor Scrolling */
/****************************************************************************************************/

//$(".stickySidebar a[rel='m_PageScroll2id']").mPageScroll2id({
//    scrollEasing: "easeInOutQuint"
//});

//$('a[href^="#"]').on('click', function (event) {
//    target = this.id.offset().top;
//    $('html,body').animate({
//        scrollTop: target
//    }, 1000);
//    event.preventDefault();
//}

// Select all links with hashes
$('a[href*="#"]')
// Remove links that don't actually link to anything
.not('[href="#"]').not('[href="#0"]').click(function (event) {
  // On-page links
  if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
    // Figure out element to scroll to
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    // Does a scroll target exist?
    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      event.preventDefault();
      scrollToLocation(target);

      //$('html, body').animate({
      //    scrollTop: target.offset().top - 50
      //}, 1000, function () {
      //    // Callback after animation
      //    // Must change focus!
      //    var $target = $(target);
      //    //$target.focus();
      //    //if ($target.is(":focus")) { // Checking if the target was focused
      //    //    return false;
      //    //} else {
      //    //    $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
      //    //    $target.focus(); // Set focus again
      //    //};
      //});
    }
  }
});

/****************************************************************************************************/
/* Window Resizing */
/****************************************************************************************************/

$(window).on('resize', function () {
  refreshDimensions();
});

/****************************************************************************************************/
/* Containers */
/****************************************************************************************************/

function refreshScrollbarWidthValue() {
  var scrollbarWidth = 16; // px (standard measured manually on Chrome)
  try {
    scrollbarWidth = getScrollbarWidth();
  } catch {
    console.log("unable to calculate scrollbar width automatically.");
  }
}
function getTopLevelScrollBarWidth() {
  var scrollbarWidth = 0;
  if (document.body.scrollHeight > document.body.clientHeight || document.documentElement.scrollHeight > document.documentElement.clientHeight) {
    scrollbarWidth = getScrollbarWidth();
  }
  return scrollbarWidth;
}

/* Updates the max-width of edge-to-edge containers to account for scrollbars */
function refreshForcedWidthContainers() {
  //var scrollbarWidth = 16; // px (standard measured manually on Chrome)
  //try {
  //    scrollbarWidth = getScrollbarWidth();
  //    console.log({ scrollbarWidth });
  //}
  //catch {
  //    console.log("unable to calculate scrollbar width automatically.");
  //}
  var scrollbarWidth = getTopLevelScrollBarWidth();
  //var width = "calc(100vw - " + scrollbarWidth + "px)";
  //var $forcedWidthContainers = $(".container.edge, .container.force");
  //$forcedWidthContainers.each(function () {
  //    $(this).css({
  //        //width: width,
  //        maxWidth: "100vw"
  //    });
  //});
  //$edgeWidthContainers.each(function () {
  //    $(this).css({
  //        //width: width,
  //        maxWidth: "100vw"
  //    });
  //});
  // ToDo: try doing this with a custom property instead:
  let root = document.documentElement;
  root.style.setProperty('--scrollbar-width', scrollbarWidth + "px");
}
function getScrollbarWidth() {
  //debugger;

  // Creating invisible container
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Removing temporary elements from the DOM
  outer.parentNode.removeChild(outer);
  return scrollbarWidth;
}

/****************************************************************************************************/
/* Hyperlinks */
/****************************************************************************************************/

// Show a warning message / disclaimer when clicking on an email link
window.addEventListener('DOMContentLoaded', function () {
  $(document).on("click", 'a[href^="mailto"]', function () {
    return confirm("Do not send any confidential information to us by e-mail or otherwise unless we have expressly confirmed a lawyer client relationship with you.");
  });
});

// Dynamically add the appropriate aria-describedby reference to links
window.addEventListener('DOMContentLoaded', function () {
  if (!isSitefinityEditor()) {
    // only run this on the front-end to prevent the changes from accidentally getting saved into the post
    updateDynamicHyperlinkStylesAndAttributes();
  }
});
function updateDynamicHyperlinkStylesAndAttributes() {
  $(".cmsContent a, .sf-Long-text a").each(function () {
    var hyperlinkUrl = $(this).attr("href");
    var linkOpensInNewTab = $(this).attr("target") && $(this).attr("target") === "_blank";
    if (isExternalUrl(hyperlinkUrl)) {
      if (linkOpensInNewTab) {
        // opens an external link in a new tab
        $(this).attr("aria-describedby", "new-window-2").attr("rel", "noopener");
      } else {
        // opens an external link
        $(this).attr("aria-describedby", "new-window-1").attr("rel", "noopener");
      }
    } else if (linkOpensInNewTab) {
      // opens link in a new tab
      $(this).attr("aria-describedby", "new-window-0").attr("rel", "noopener");
    }
  });
}
window.destinationUrl = ""; // holds the url of the last link clicked

// store the destination url to be used for page loading animation logic
$(document).on("click", "a[href]", function (event) {
  window.destinationUrl = $(this).attr("href");
});

/****************************************************************************************************/
/* Sliders / Carousels */
/****************************************************************************************************/

/* shared event callbacks */
var autoHeightSingleItemSliderEvents = {
  beforeMounted: initAutoHeightSingleItemSlider,
  mounted: initAutoHeightSingleItemSlider,
  refresh: initAutoHeightSingleItemSlider,
  resized: initAutoHeightSingleItemSlider,
  move: doAutoHeightSingleItemSlider
};
var autoHeightMultiItemSliderEvents = {
  //move: function (newIndex, prevIndex, destIndex, splide) {
  //    let visibleSlides = splide.root.querySelectorAll('.splide__slide.is-visible');
  //    for (var i = 0; i < visibleSlides.length; i++) {
  //        // get the range of slides based on the options
  //        let futureSlides = splide.Components.Elements.slides[newIndex + i]
  //    }

  //    //let currentHeight = splide.Components.list.offsetHeight;
  //    //let nextItemHeight = splide.Components.Elements.slides[newIndex].offsetHeight;
  //    //splide.Components.list.style.height = Math.max(currentHeight, nextItemHeight) + "px";
  //},
  //visible: doAutoHeightMultiItemSlider,
  moved: doAutoHeightMultiItemSlider,
  mounted: initAutoHeightMultiItemSlider,
  refresh: initAutoHeightMultiItemSlider,
  resized: initAutoHeightMultiItemSlider,
  beforeMounted: initAutoHeightMultiItemSlider
};
function initAutoHeightSingleItemSlider(splide) {
  if (splide.Components.Elements.slides.length <= 1) {
    splide.Components.Elements.arrows.style.display = "none";
    splide.destroy();
  }
  splide.Components.Elements.list.style.alignItems = "flex-start";
  var height = splide.Components.Elements.slides[splide.index].offsetHeight;
  updateSliderHeight(splide, height);
  if (typeof updateSidebarOffsetValues === "function") {
    updateSidebarOffsetValues();
  }
}
function initAutoHeightMultiItemSlider(splide) {
  splide.Components.Elements.list.style.alignItems = "flex-start";
  let height = getVisibleSlideHeight(splide);
  if (height) {
    updateSliderHeight(splide, height);
  }
}
function updateSliderHeight(splide, height) {
  if (splide && height) {
    splide.Components.Elements.track.style.transitionProperty = "height";
    splide.Components.Elements.track.style.transitionDuration = splide.options.speed + "ms";
    splide.Components.Elements.track.style.transitionTimingFunction = "ease";
    splide.Components.Elements.track.style.height = height + "px";
  }
}
;
function doAutoHeightSingleItemSlider(newIndex, prevIndex, destIndex, splide) {
  var height = splide.Components.Elements.slides[newIndex].offsetHeight;
  updateSliderHeight(splide, height);
  updateSidebarOffsetValues();
}
function getVisibleSlideHeight(splide) {
  let height = 0;
  let visibleSlides = splide.root.querySelectorAll('.splide__slide.is-visible');
  if (visibleSlides && visibleSlides.length) {
    for (var slide of visibleSlides) {
      height = Math.max(slide.offsetHeight, height);
    }
  }
  return height;
}
function doAutoHeightMultiItemSlider(newIndex, prevIndex, destIndex, splide) {
  let height = getVisibleSlideHeight(splide);
  if (height) {
    updateSliderHeight(splide, height);
  }
}

/*
 Global splide config. Used a base for ALL splide sliders. 
 */
window.globalSplideConfig = {
  type: 'loop'
  //start: 0,
  //perPage: 1,
  //perMove: 1,
  //pagination: true,
  //arrows: false,
  //autoHeight: true,
  //rewind: false,
  //speed: '500',
  //autoplay: true,
  //easing: 'cubic-bezier(.12,.8,.47,.98)',
  //accessibility: true,
  //classes: {
  //    //arrows: 'splide__arrows your-class-arrows',
  //    //arrow: 'splide__arrow your-class-arrow',
  //    prev: 'splide__arrow--prev fas fa-chevron-left',
  //    next: 'splide__arrow--next fas fa-chevron-right',
  //},
  //throttle: 10, // throttle the resize function (default 100 ms)
};

/*
 Slider presets. These get merged with the globalSplideConfig options to configure ALL splide sliders throughout the site.
 */
window.SplideConfigurations = [/* Default configuration */
{
  name: "default",
  //start: 0,
  type: 'loop',
  perPage: 3,
  perMove: 1,
  breakpoints: {
    1024: {
      perPage: 2
    },
    640: {
      perPage: 1
    }
  },
  variants: [{
    // config that inherits/overrides a parent config
    name: "default-no-dots",
    dots: false
  }]
}, /* Single Slide Resources */
{
  name: "single",
  type: 'loop',
  start: 0,
  perPage: 1,
  perMove: 1,
  variants: [{
    name: "single-auto-height",
    autoHeight: true,
    fixedHeight: false,
    on: Object.assign(autoHeightSingleItemSliderEvents, {// combine shared events with custom ones
      // move: function(){}
    })
  }]
}, /* Double (2-item) sliders  */
{
  name: "double",
  type: 'loop',
  start: 0,
  perPage: 2,
  perMove: 2,
  gap: "1rem",
  padding: {
    left: "1rem"
  },
  breakpoints: {
    768: {
      perPage: 1
    }
  },
  variants: [{
    name: "double-auto-height",
    autoHeight: true,
    fixedHeight: false,
    on: Object.assign(autoHeightSingleItemSliderEvents, {// combine shared events with custom ones
      // move: function(){}
    })
  }]
},
//{
//    name: "featured-items",
//    autoHeight: true,
//    fixedHeight: false,
//    on: Object.assign(autoHeightSingleItemSliderEvents, { // combine shared events with custom ones
//        // move: function(){}
//    }),
//    type: 'loop',
//    start: 0,
//    perPage: 2,
//    perMove: 2,
//    breakpoints: {
//        768: {
//            perPage: 1,
//        },
//    },
//    variants: [
//        {

//        },
//    ]
//},
/* Homeslideshow / Hero */
{
  name: "hero",
  type: 'fade',
  start: 0,
  interval: 6000,
  perMove: 1,
  pauseOnHover: false,
  pauseOnFocus: false,
  arrows: false,
  pagination: true,
  autoplay: true,
  resetProgress: true,
  on: {
    mounted: function () {
      $(".homeSlideshow h1 .line").wrapInner("<span class='lineInner'></span>");
    }
  }
}, /* Fade */
{
  name: "fade",
  type: 'fade',
  start: 0,
  perPage: 1,
  perMove: 1
}, /* Fixed Width */
{
  name: "fixedWidth",
  fixedWidth: '32rem',
  type: 'loop',
  start: 0,
  perPage: 1,
  perMove: 1,
  breakpoints: {
    600: {
      fixedWidth: '18rem'
    }
  }
}, /* Featured Items */
{
  name: "featured",
  //autoWidth: true,
  type: 'loop',
  start: 0,
  perPage: 3,
  perMove: 1,
  breakpoints: {
    1299: {
      perPage: 3
    },
    1024: {
      perPage: 2
    },
    768: {
      perPage: 1
    }
  },
  on: Object.assign(autoHeightMultiItemSliderEvents, {// combine shared events with custom ones
    // move: function(){}
  })
}, /* Sponsorships */
{
  name: "sponsorships",
  //start: 0,
  gap: 0,
  type: 'loop',
  perPage: 5,
  perMove: 1,
  pagination: false,
  autoplay: true,
  interval: 3000,
  breakpoints: {
    1024: {
      perPage: 3
    },
    767: {
      perPage: 2
    },
    500: {
      perPage: 1
    }
  }
}];
function doFeaturedSlideResize(splide) {
  if (splide.Components && splide.Components.Elements) {
    var featuredSlide = splide.Components.Elements.slides.find(obj => {
      return obj.classList.contains("slide-featured");
    });
    if (featuredSlide) {
      var $parent = $(splide.root).parent();
      var width = $parent.innerWidth();
      $parent[0].style.setProperty("--track-width", width + "px");
    }
  }
}

/* Get a splide configration matching a given name */
window.getSplideConfiguraion = function (splideConfigurationName = "default") {
  let mergedConfiguration = {};
  for (var configuration of window.SplideConfigurations) {
    if (configuration.name === splideConfigurationName) {
      mergedConfiguration = Object.assign({}, configuration);
      break;
    } else if (configuration.hasOwnProperty("variants") && configuration.variants.length) {
      for (var variant of configuration.variants) {
        if (variant.name === splideConfigurationName) {
          mergedConfiguration = Object.assign({}, configuration, variant);
          // remove unneeded properties
          delete mergedConfiguration.variants;
          //delete mergedConfiguration.name;
          break;
        }
      }
    }
  }
  mergedConfiguration = Object.assign({}, window.globalSplideConfig, mergedConfiguration);
  //console.log(splideConfigurationName, mergedConfiguration);
  return mergedConfiguration;
};

/* Loop through our widget / view sliders and initiate them using their preset configs */
var splideSliders = [];
if (typeof Splide !== "undefined") {
  $(".splide[data-splide-preset]").not(".is-active").each(function (i, el) {
    let $slider = $(this);
    let configurationName = $slider.attr("data-splide-preset");
    let configuration = getSplideConfiguraion(configurationName);
    let splide = new Splide($slider[0], configuration);

    /* register custom event callbacks defined in the configuration object */
    if (typeof configuration.on !== "undefined") {
      for (const eventName in configuration.on) {
        splide.on(eventName, function (...args) {
          var callback = configuration.on[eventName];
          callback(...args, splide); // this gives us access to the Splide object inside of the handler function
        });
      }
    }
    splideSliders.push(splide);
    splide.mount();
  });
}

/* fix for banner resizing */
$(window).on("resize", function () {
  for (var i = 0; i < splideSliders.length; i++) {
    splideSliders[i].refresh();
  }
});

//window.addEventListener('DOMContentLoaded', function () {
//    var main = new Splide('#galleryslider', {
//        type: 'fade',
//        //cover: true,
//        rewind: true,
//        pagination: false,
//        //heightRatio: 0.5,
//    });

//    var thumbnails = new Splide('#thumbnails', {
//        fixedWidth: 120,
//        fixedHeight: 80,
//        gap: 10,
//        rewind: true,
//        pagination: false,
//        //cover: true,
//        isNavigation: true,
//        //breakpoints: {
//        //    600: {
//        //        fixedWidth: 60,
//        //        fixedHeight: 44,
//        //    },
//        //},
//    });

//    main.sync(thumbnails);
//    main.mount();
//    thumbnails.mount();
//});

document.addEventListener('DOMContentLoaded', function () {
  if ($(".splide-gallery").length) {
    var main = new Splide('.splide-gallery', {
      type: 'fade',
      //cover: true,
      rewind: true,
      perPage: 1,
      pagination: false
      //heightRatio: 0.2,
    });
    var thumbnails = new Splide('#thumbnail-slider', {
      fixedWidth: "10rem",
      fixedHeight: "6rem",
      gap: "1rem",
      rewind: true,
      pagination: false,
      cover: true,
      isNavigation: true,
      breakpoints: {
        600: {
          gap: "0.5rem",
          fixedWidth: 60,
          fixedHeight: 44
        }
      }
    });
    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  }
});

/****************************************************************************************************/
/* Search Box */
/****************************************************************************************************/

//$(function () {
//    var searchWrapper = $('.sfsearchBox');
//    var searchInput = searchWrapper.find('input[name="search"]');
//    var searchIndex = searchWrapper.find('input[id="hdnSearchIndex"]');
//    var searchLocation = searchWrapper.find('input[id="hdnSearchLocation"]');
//    var searchButton = searchWrapper.find('button');

//    searchButton.click(function (e) {
//        e.preventDefault();

//        var index = searchIndex.val();
//        var value = searchInput.val().trim();
//        var location = searchLocation.val().trim();
//        if (index && value !== '' && location !== '') {
//            window.location = location
//                + '?indexCatalogue='
//                + index + '&searchQuery='
//                + value + '&wordsMode=0';
//        }
//    });

//    searchInput.keypress(function (e) {
//        var key = e.which;

//        // the enter key code
//        if (key === 13) {
//            searchButton.click();
//            return false;
//        }
//    });
//});

/****************************************************************************************************/
/* Facts / Counters */
/****************************************************************************************************/

const el = document.querySelector('.counter');

// Start counting, do this on DOM ready or with Waypoints.
//counterUp(el, {
//    duration: 1000,
//    delay: 16,
//});

window.addEventListener('DOMContentLoaded', function () {

  //var $counters = $('.counter');
  //if ($counters.length) {
  //    $counters.each(function (i, counter) {
  //        // No need to call waypoints manually ... the counter-up plugin has the call built-in
  //        $(counter).counterUp({
  //            delay: 20,
  //            time: 2000
  //        });
  //    });
  //}
});

/****************************************************************************************************/
/* Waypoints + Scroll animations */
/****************************************************************************************************/

// Side title animation
var waypointsTitles = $(".sideTitle").waypoint({
  handler: function (direction) {
    $(this.element).addClass("animate");
  },
  continuous: true,
  offset: '65%'
});
var waypointsFooterBottom = $(".mainFooterGrid").waypoint({
  handler: function (direction) {
    $("body").addClass("scrolledToBottom");
  },
  continuous: true,
  offset: 'bottom-in-view'
});

// update the selector to match any element that you want to fade-in
var waypointsFadeInSelector = ".cardView, .fadeIn, .sideTitle, .viewAllMoreWrapper, .sideTitleWrapper, .footerLeftGrid, .footerRight, .cmsContent p, .cmsContent > *";
var waypointsFadeInSelectorsToIgnore = ".cardView.searchResult";
window.$waypointsFadeInElements = $(""); // this is intentionally empty

window.refreshWaypointsElements = function () {
  var $newElements = $(waypointsFadeInSelector).not(window.$waypointsFadeInElements).not($(waypointsFadeInSelectorsToIgnore));
  $newElements.addClass("preFadeIn");
  $newElements.waypoint({
    handler: function (direction) {
      $(this.element).addClass("fadeIn");
    },
    continuous: true,
    offset: '95%'
  });
  window.$waypointsFadeInElements.add($newElements);
};

// run this function every time you add a new element to the page (if that element needs to register a waypoint)
if (!isSitefinityEditor() && !isMobile()) {
  window.refreshWaypointsElements(); // init/refresh waypoints fade-ins
} else {
  $(waypointsFadeInSelector).not(window.$waypointsFadeInElements).not($(waypointsFadeInSelectorsToIgnore)).addClass("fadeIn");
}

/****************************************************************************************************/
/* Lazy Loading Images : http://jquery.eisbehr.de/lazy/ */
/****************************************************************************************************/

$('.lazy').lazy({
  threshold: -150,
  // images will load when [threshold]px from viewport edge
  afterLoad: function (element) {
    $(element).addClass("lazy-loaded");
  }
});

// Needed for lazy loading in some sliders to load images on click/swipe of next slide
//function scrollUpDown1px() {
//    setTimeout(function () {
//        $(window).scrollTop($(window).scrollTop() - 1);
//        $(window).scrollTop($(window).scrollTop() + 1);
//    }, 250);
//}

/****************************************************************************************************/
/* Forms / Autofill */
/****************************************************************************************************/

// SEARCH BOX - PLACEHOLDER TEXT
$('.search input[type="text"]').attr("placeholder", "How Can We Help You?");

// Fix for Chrome Form Autofill for our contact form
$(".contactForm input[name*=Name]").attr('autocomplete', 'name');
$(".contactForm input[name*=Email]").attr('autocomplete', 'email');
$(".contactForm input[name*=Phone]").attr('autocomplete', 'tel');
// Or you could turn it off
//$('form').attr('autocomplete', 'off');

/****************************************************************************************************/
/* Misc */
/****************************************************************************************************/

// check if we're running inside the SF Page editor
function isSitefinityEditor() {
  return $("body").hasClass("sfPageEditor") || typeof sitefinity === "object";
}
function isMobile() {
  return window.innerWidth < 768;
}

// Check if a link is relative to the current base URL
function isRelativeUrl(url) {
  var regex = new RegExp('^(?:[a-z]+:)?//', 'i');
  return regex.test(url);
}

// check if a given URL is external (or different from the current one at least)
function isExternalUrl(url) {
  var match = url.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
  if (typeof match[1] === "string" && match[1].length > 0 && match[1].toLowerCase() !== location.protocol) return true;
  if (typeof match[2] === "string" && match[2].length > 0 && match[2].replace(new RegExp(":(" + {
    "http:": 80,
    "https:": 443
  }[location.protocol] + ")?$"), "") !== location.host) return true;
  return false;
}
$.fn.isHScrollable = function () {
  return this[0].scrollWidth > this[0].clientWidth;
};
$.fn.isVScrollable = function () {
  return this[0].scrollHeight > this[0].clientHeight;
};
$.fn.isScrollable = function () {
  return this[0].scrollWidth > this[0].clientWidth || this[0].scrollHeight > this[0].clientHeight;
};

// Expand Expertise section (Home Page)
$(".btnExpandExpertise").on("click", function () {
  $(".expertiseExpandable").slideToggle({
    duration: 300,
    easing: "swing"
  });
});

// Clickable items (e.g. a clickable article card with nested links)
$(document).on("click", ".clickable", function (event) {
  var $clickable = $(this);
  if (!isSitefinityEditor()) {
    var itemUrl = "";
    var target = "_self"; // default

    // allow nested hyperlinks to work
    if ($(event.target).is('a[href]')) {
      return;
    }

    // Look for data attributes on the clickable element
    else if (typeof $clickable.data("url") !== 'undefined' && $clickable.data("url").length) {
      itemUrl = $clickable.data("url");
      if (typeof $clickable.data("target") !== 'undefined' && $clickable.data("target").length) {
        target = $clickable.data("target");
      }
    } else {
      // Otherwise, find the first child hyperlink and use that
      var $firstLinkFound = $clickable.find("a[href]").first();
      if ($firstLinkFound.length) {
        itemUrl = $firstLinkFound.attr("href");
        target = $firstLinkFound.attr("target") ? $firstLinkFound.attr("target") : target;
      } else {
        return;
      }
    }

    // Open the page if a url was found
    if (itemUrl) {
      event.preventDefault();
      window.open(itemUrl, target);
      return false;
    } else {
      return;
    }
  }
});

/****************************************************************************************************/
/* Accordions */
/****************************************************************************************************/

var groupClass = "group";
var expandedClass = "active";
window.addEventListener('DOMContentLoaded', function () {
  var $accordions = $(".accordion"); //.not(".disabled");
  if ($accordions.length && !isSitefinityEditor()) {
    // Add accessibility attributes
    updateAccordionAccessibilityAtts();

    // Add expand/collapse all button to first accordion
    //$accordions = $(".accordion");
    //if ($accordions.length > 1) {
    //    $("<div class='btnExpandAll expand'>Expand All</div>").prependTo($accordions.first());
    //    $accordions.first().addClass("hasExpandAll");
    //}
    // ToDo: Find a better way of adding the expand/collapse all button without making the <dl> markup invalid

    // Expand first 
    if ($(".accordion." + expandedClass).length) {
      expandAccordion($(".accordion." + expandedClass).first());
    }

    // Open all accordions with the "active" class
    $(".accordion.active").each(function () {
      var $accordion = $(this);
      expandAccordion($accordion);
    });

    // Click & Keypress handlers
    $(".accordion .accordionTop").on("click", function (ev) {
      toggleAccordion($(this).parent(".accordion"));
    }).on("keypress", function (ev) {
      if (ev.which === 13) {
        // enter key code
        toggleAccordion($(this).parent(".accordion"));
      }
    });

    // Expand / Collapse All accordions
    $(".btnExpandAll").on("click", function () {
      //debugger;
      var $button = $(this);
      if ($button.hasClass("expand")) {
        $accordions.each(function () {
          expandAccordion($(this)); // expand each accordion
        });
        updateExpandAllButton();
      } else {
        $accordions.each(function () {
          collapseAccordion($(this)); // close each accordion
        });
        updateExpandAllButton();
      }
    });
  }
});
function updateAccordionAccessibilityAtts() {
  // Make sure they're tab navigable/focusable
  $(".accordion").each(function (i, el) {
    var $accordion = $(el);
    var $accordionTop = $accordion.find(".accordionTop");
    var $accordionBottom = $accordion.find(".accordionBottom");
    if ($accordionTop.length && $accordionBottom.length) {
      // make sure accordionBottoms have unique Ids
      var accordionTopId = $accordionTop.uniqueId().attr("id");
      var accordionBottomId = $accordionBottom.uniqueId().attr("id");

      // make accodions focusable
      $accordionTop.attr("tabindex", "0");
      $accordionTop.attr("role", "button");
      var accordionTitle = $accordionTop.text().trim();
      if (!$accordionTop[0].hasAttribute("aria-label") && $accordionTop.attr("aria-label") !== "") {
        $accordionTop.attr("aria-label", accordionTitle);
        $accordionBottom.attr("aria-labeledby", accordionTopId);
        $accordionTop.attr("aria-controls", accordionBottomId);
        if ($accordionTop.is(".active")) {
          $accordionTop.attr("aria-expanded", "true");
          $accordionBottom.attr("aria-hidden", "false");
        } else {
          $accordionTop.attr("aria-expanded", "false");
          $accordionBottom.attr("aria-hidden", "true");
        }
      }
    }
  });
}

// Update the expand button to reflect current state of accordions
function updateExpandAllButton() {
  var $button = $(".btnExpandAll");
  var $accordions = $(".accordion");
  var $activeAccordions = $accordions.filter(".active");
  if ($button.length && $accordions.length > $activeAccordions.length) {
    // if some are open (but not all) then set to expand
    $button.addClass("expand");
    $button.text("Expand All");
  } else {
    $button.removeClass("expand");
    $button.text("Collapse All");
  }
}

// Toggle the target accordion
function toggleAccordion($accordion) {
  if ($accordion.hasClass(expandedClass)) {
    collapseAccordion($accordion);
  } else {
    closeGroupMembers($accordion); // close group members first
    expandAccordion($accordion);
  }
  updateExpandAllButton();
}

// Expand single accordion (and upate group)
function expandAccordion($accordion) {
  $accordion.addClass(expandedClass);
  $accordion.find(".accordionTop").addClass(expandedClass);
  $accordion.find(".accordionTop").attr("aria-expanded", "true");
  $accordion.find(".accordionBottom").addClass(expandedClass).slideDown();
  $accordion.find(".accordionBottom").attr("aria-hidden", "false");
  $accordion.find(".accordionBottom").prop("hidden", false);
  updateExpandAllButton();
}

// Close single accordion (and upate group)
function collapseAccordion($accordion) {
  $accordion.removeClass(expandedClass);
  $accordion.find(".accordionTop").removeClass(expandedClass);
  $accordion.find(".accordionTop").attr("aria-expanded", "false");
  $accordion.find(".accordionBottom").removeClass(expandedClass).slideUp();
  $accordion.find(".accordionBottom").attr("aria-hidden", "true");
  $accordion.find(".accordionBottom").prop("hidden", true);
  updateExpandAllButton();
}

// Check if accordion in group. If so, update group members
function closeGroupMembers($accordion) {
  var classes = $accordion[0].className.trim().split(/ |\t|\|/); // get array of classes (regex to account for space, tab, and pipe separators)
  var groups = $.grep(classes, function (classes, i) {
    // get only the classes containing groupClass
    return classes.indexOf(groupClass) === 0;
  });
  $.each(groups, function (i, group) {
    $(".accordion." + group).each(function () {
      collapseAccordion($(this)); // close each grouped accordion
    });
  });
}

/****************************************************************************************************/
/* Toggle Container / Expandable Content */
/****************************************************************************************************/
/* - these are LIKE accordions, but don't always have the same features or require the same markup. */
/* - Intended for more general purpose expand / collapse functionality) */
/****************************************************************************************************/

// Toggle Sections
window.addEventListener('DOMContentLoaded', function () {
  var expandedClass = "active";
  $(".toggleAction").on("click", function () {
    toggleContent($(this).next(".toggleContent"));
    return false;
  }).on("keypress", function (e) {
    if (e.which === 13) {
      // enter key code
      toggleContent($(this).next(".toggleContent"));
      return false;
    }
  });

  // Open the First
  //$(".toggleAction").first().trigger('click');

  // Toggle the Content
  function toggleContent($toggleSection) {
    if ($toggleSection.parent().hasClass(expandedClass)) {
      collapseToggleContent($toggleSection);
    } else {
      //updateGroup($toggleSection);
      expandToggleContent($toggleSection);
    }
  }
  function updateGroup($toggleSection) {
    var groupName = $toggleSection.parent().attr("data-accordion-group");
    if (groupName) {
      $("[data-accordion-group='" + groupName + "']").each(function () {
        collapseToggleContent($(this).find(".toggleContent"));
      });
    }
  }
  function expandToggleContent($toggleSection) {
    $toggleSection.parent().addClass(expandedClass);
    $toggleSection.slideDown();
  }

  // Close single accordion (and update group)
  function collapseToggleContent($toggleSection) {
    $toggleSection.parent().removeClass(expandedClass);
    $toggleSection.slideUp();
  }
});
$(document).on("click", "button.playAudio", function (ev) {
  //let audioFileId = $(this).parents(".audioPlayerWrapper").data("audio-id");
  let audioFileUrl = $(this).parents(".audioPlayerWrapper").data("audio-source");
  //let audioFileType = $(this).parents(".audioPlayerWrapper").data("audio-type");

  if (audioFileUrl) {
    const audio = new Audio(audioFileUrl);
    audio.play();
  }
  ev.stopPropagation();
  return false;
});

/* Read More Content (expandable content sections) */
$(".toggleReadMore").on("click", function () {
  var $readMoreContent = $(".readMoreContent");
  if ($readMoreContent.is(".visible")) {
    // hide
    $readMoreContent.removeClass("visible");
    $(this).text("Read More");
    $readMoreContent.slideUp({
      complete: function () {
        if (typeof updateSidebarOffsetValues === "function") {
          updateSidebarOffsetValues();
        }
      }
    });
  } else {
    // show
    $readMoreContent.slideDown({
      complete: function () {
        if (typeof updateSidebarOffsetValues === "function") {
          updateSidebarOffsetValues();
        }
      }
    });
    $readMoreContent.addClass("visible");
    $(this).text("Read Less");
  }
});

/* #endregion */
/****************************************************************************************************/

/****************************************************************************************************/
/* #region Checkbox Groups ("all" button logic) */
/****************************************************************************************************/

$(".checkboxGroup :checkbox[value=all]").click(function () {
  $(this).closest('.checkboxGroup').find(':checkbox').not(this).prop('checked', this.checked);
});
$('.checkboxGroup :checkbox').not('[value=all]').click(function () {
  var $all = $(this).closest('.checkboxGroup').find('[value=all]');
  var $chks = $(this).closest('.checkboxGroup').find(':checkbox').not($all);
  $all.prop('checked', $chks.length == $chks.filter(':checked').length);
});

/* #endregion */
/****************************************************************************************************/

/****************************************************************************************************/
/* #region Misc AODA fixes */
/****************************************************************************************************/

// clears up a minor alert about duplicate links in the footer menu
if (!$("body .printWrapper").length) {
  var $redundantExpertiseLinks = $(".navCustomUl a[href='/expertise']");
  if ($redundantExpertiseLinks.length = 2) {
    $redundantExpertiseLinks.eq(1).removeAttr("href").attr("onclick", "window.location.href='/expertise'");
  }
}

// remove the <noscript> tag - this is purely to remove another notice from WAVE (it should not make any real difference ...)
//var noscript = document.querySelector('noscript');
//noscript.parentNode.removeChild(noscript);
removeNoScriptTags();
window.addEventListener('DOMContentLoaded', function () {
  removeNoScriptTags();
});
function removeNoScriptTags() {
  $("noscript").each(function () {
    $(this).remove(); // this only runs if the main JS bundle is loaded, and therefore should not matter
  });
}

/* #endregion */
/****************************************************************************************************/